var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass:
        "header__links__items header__email-signup header__email-signup--mobile"
    },
    [
      _c(
        "lightbox-button",
        { attrs: { target: "lightboxMarketoEmailSignup" } },
        [
          _c("p", { staticClass: "header__links--child__label" }, [
            _vm._v(_vm._s(_vm.label))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "lightbox",
        { attrs: { name: "lightboxMarketoEmailSignup" } },
        [
          _c(
            "lightbox-wrapper",
            { staticClass: "lightbox__wrapper--white" },
            [
              _c("lightbox-close"),
              _vm._v(" "),
              _c("header", [
                _c("h2", { staticClass: "font__color--orange" }, [
                  _vm._v(_vm._s(_vm.header.blog.marketo.header))
                ])
              ]),
              _vm._v(" "),
              _c("marketo", {
                attrs: {
                  id: _vm.header.blog.marketo.id,
                  cta: _vm.header.blog.marketo.cta
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "header__rss" }, [
                _c(
                  "a",
                  {
                    attrs: { href: _vm.header.blog.rss.href, target: "_blank" }
                  },
                  [
                    _c("svg", { staticClass: "header__rss__icon" }, [
                      _c("use", { attrs: { "xlink:href": "#rss" } })
                    ]),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.header.blog.rss.label) +
                        "\n        "
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }